import { QUESTIONNAIRE_INVENTORIES, Inventory } from 'lib/documents';
import { ComponentType } from 'react';
import { ImpactQuestionnaire } from '../../questionnaires/impact';
import { PendingAssessmentData } from '../questionnaire-control-flow-slice-types';
import {
  IntroDemographic,
  IntroInjury,
  IntroPromisA,
  IntroCgs,
  IntroPcs,
  IntroDhi,
  QuestionnaireIntroWrapperProps
} from '../_components/questionnaire-intros';

type InventoryObject = {
  overview?: PendingAssessmentData | undefined;
  pendingInventoryData?: Partial<
    Record<(typeof QUESTIONNAIRE_INVENTORIES)[number], Inventory | undefined>
  >;
};
type FlowState = {
  condition: (props: InventoryObject) => boolean;
  render: ComponentType<QuestionnaireIntroWrapperProps>;
};
const QUESTIONNAIRE_FLOW: FlowState[] = [
  {
    condition: d => !d.pendingInventoryData?.inventoriesDemographic,
    render: IntroDemographic
  },
  {
    /**
     * This questionnaire only appears in post-injury tests
     * @param d
     * @returns
     */
    condition: d =>
      !d.pendingInventoryData?.inventoriesInjury &&
      d.overview?.assessmentType === 'post-injury',
    render: IntroInjury
  },
  {
    condition: d => !d.pendingInventoryData?.inventoriesPromis,
    render: IntroPromisA
  },
  {
    condition: data => !data.pendingInventoryData?.inventoriesCgs,
    render: IntroCgs
  },
  {
    condition: data => !data.pendingInventoryData?.inventoriesPcs,
    render: IntroPcs
  },
  {
    condition: data => !data.pendingInventoryData?.inventoriesDhi,
    render: IntroDhi
  },
  {
    condition: data => !data.pendingInventoryData?.inventoriesImpact,
    render: ImpactQuestionnaire
  }
];

export function resolveNeededComponent(data: InventoryObject) {
  const node = QUESTIONNAIRE_FLOW.find(_ => _.condition(data));
  if (!node) {
    return null;
  }

  return node.render;
}
